import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FieldProps } from "formik";

export default function IcomInput({
  field,
  form,
  icon,
  type,
  placeholder,
  innerRef,
}: FieldProps & {
  icon: any;
  type: string;
  placeholder: string;
  innerRef: any;
}) {
  const [state, setState] = useState({
    showPassword: false,
  });
  const hasErrors = form.touched[field.name] && form.errors[field.name];
  const Icon = icon;

  return (
    <div
      className={`relative flex gap-1 items-center rounded-md border p-3 px-4 text-gray-900 focus-within:border-primary-blue-500
    ${
      hasErrors
        ? "focus-within:border-feedback-negative-500 border-feedback-negative-500"
        : "focus-within:border-primary-blue-500 border-neutral-gray-100"
    }
    `}
    >
      {Icon && (
        <Icon
          className={
            hasErrors
              ? "stroke-feedback-negative-500"
              : "stroke-neutral-gray-400"
          }
        />
      )}
      {type === "textarea" ? (
        <textarea
          ref={innerRef}
          className={`w-full outline-0 ${
            hasErrors ? "text-feedback-negative-500" : "text-neutral-gray-600"
          }`}
          placeholder={placeholder}
          {...field}
        />
      ) : (
        <input
          ref={innerRef}
          {...field}
          className={`w-full outline-0 ${
            hasErrors ? "text-feedback-negative-500" : "text-neutral-gray-600"
          }`}
          placeholder={placeholder}
          type={type === "password" && state.showPassword ? "text" : type}
        />
      )}

      {type === "password" ? (
        <button
          type="button"
          onClick={() =>
            setState((s) => ({ ...s, showPassword: !s.showPassword }))
          }
        >
          {state.showPassword ? (
            <FaEyeSlash fill="#B3B4C2" />
          ) : (
            <FaEye fill="#B3B4C2" />
          )}
        </button>
      ) : (
        ""
      )}
    </div>
  );
}
